export default __webpack_public_path__ + "static/upcomingimg5-387e059ab814226730bc2ddfd41c07d6.png";